// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { LocalStorage } from '@shared/commons/LocalStorage';
export class BrokerMessageCustomButton {
    constructor() {
        this.fTitle = null;
        this.fTooltip = null;
        this.fURL = null;
        this.fAliases = null;
    }
    get Title() {
        let result = this.fTitle;
        if (this.fAliases) {
            const alias = this.fAliases[LocalStorage.getLanguage()];
            if (alias === null || alias === void 0 ? void 0 : alias.Name) {
                result = alias.Name;
            }
        }
        return result;
    }
    get Tooltip() {
        let result = this.fTooltip;
        if (this.fAliases) {
            const alias = this.fAliases[LocalStorage.getLanguage()];
            if (alias === null || alias === void 0 ? void 0 : alias.Description) {
                result = alias.Description;
            }
        }
        return result;
    }
    get URL() {
        return this.fURL;
    }
    get TitleForResponse() {
        return this.fTitle;
    }
}
